export default __webpack_public_path__ + "tenant-3-e283200aa0fea31c1431611f1815d29e.bundle.svg";